module.exports = __webpack_public_path__ + "img/lg_ring_g_0_0_null@3x.fef1be65.png";